import scroller from '../scroller';
import vars from "../../helpers";
import slider from "../slider";

const init = (parent) => {
	const container = parent.querySelectorAll('.chapter__horizontal-scroll');
	const $scroller = scroller.getElement();

	if (!container.length) {
		return;
	}

	for (let i = 0; i < container.length; i++) {
		let containerEl = container[i];
		let start = '10%';

		const isContent = containerEl.classList.contains('chapter__horizontal-scroll--content');
		const eh = containerEl.clientHeight;
		const wh = window.innerHeight;

		if (wh > eh) {
			start = `${(wh - eh) / 2}`;
		}

		if(!vars.isMobile()) {
			gsap.to(containerEl, {
				scrollTrigger: {
					trigger: containerEl,
					pinType: 'transform',
					pinReparent: true,
					pinSpacing: true,
					invalidateOnRefresh: true,
					pin: true,
					scrub: 1,
					start: `top ${isContent ? 'top' : start}`,
					end: () => `+=${containerEl.offsetWidth * (isContent ? 4 : 1)}`,
					// markers: {
					// 	startColor: 'green',
					// 	endColor: 'red',
					// },
					scroller: scroller.getElement(),
				},
				ease: 'none',
				x: () => `${-(containerEl.scrollWidth - $scroller.clientWidth)}px`,
			});
		} else {
			slider.init();
		}
	}
};

const horizontalScroll = (parent) => {
	init(parent);
};

export {horizontalScroll};
